
<template>
  <div class="complete_content">
    <dd-header
      :headerType=1
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>パスワード設定完了</h2>
        </div>
        <div class="main_content">
          <ul class="thanks">
            <li>パスワードを再設定しました。</li>
            <li>引き続きmm/styleをご利用ください。</li>
            <li>
              <router-link to="/mmstyle/top">TOPへ戻る</router-link>
            </li>
          </ul>
        </div>
        <div id="login">
          <div id="login_icon">
            <div>
              <img :src="getImage('common/logo.png')">
            </div>
            <div>
              <label>My size, My lifestyle.</label>
            </div>
          </div>
          <div class="regist_form">
            <dd-login></dd-login>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import * as App from '../../utils/App'
import {DC_STORAGE_KEY} from '../../constants/App'
// Module
import Header from '../components/common/DcHeader'
import LoginForm from '../components/login/LoginForm'

export default {
  name: 'orderComplete',
  components: {
    'dd-header': Header,
    'dd-login': LoginForm
  },
  data () {
    return {
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  created () {
    App.removeLocalStorage(DC_STORAGE_KEY.FILE_NAME)
    App.removeLocalStorage(DC_STORAGE_KEY.TOP_FORM)
    App.removeLocalStorage(DC_STORAGE_KEY.PRICE_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.DELIVERY_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.SEL_BUSINESS)
    App.removeLocalStorage(DC_STORAGE_KEY.STRUCT_DATA)
    App.removeLocalStorage(DC_STORAGE_KEY.PAGE_LIST)
    App.removeLocalStorage(DC_STORAGE_KEY.SELECT_PLAN)
  }

}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>
<style src="../css/login.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/PasswordResetComplete.vue